import styled from "styled-components";
import { KOGTableRow } from "@/main/components/shared/boxGrid/styles";

export const Container = styled(KOGTableRow)`
	&&& {
		.MuiIconButton-root.Mui-disabled {
			color: rgba(0, 0, 0, 0.34);
		}
		.TableCell-Status {
			width: 120px;
		}
		.TableCell-SizeSmall {
			width: 200px;
		}
		.TableCell-SizeMedium {
			width: 20%;
			text-align: center;
		}
		.TableCell-AlignCenter {
			text-align: center;
		}
	}
`;

interface ICustomColumn {
	$width?: string;
}
export const CustomColumn = styled.div<ICustomColumn>`
	width: 100%;
	max-width: ${({ $width }) => $width || "100%"};
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;
export const CenterColumn = styled.div`
	width: 100%;
	text-align: center;
`;

export const BoxModal = styled.div`
	background-color: #fff;
	border-radius: 8px;
	padding: 15px;
	width: 400px;
`;
